/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CancellationReasonDriverBooking {
	CANCELLED_BY_DRIVER_NO_SHOW = 'CANCELLED_BY_DRIVER_NO_SHOW',
	CANCELLED_BY_DRIVER_WRONG_PASSENGER_NAME = 'CANCELLED_BY_DRIVER_WRONG_PASSENGER_NAME',
	CANCELLED_BY_DRIVER_WRONG_BOOKING_INFO = 'CANCELLED_BY_DRIVER_WRONG_BOOKING_INFO',
	CANCELLED_BY_DRIVER_UNCOOPERATIVE_PASSENGER = 'CANCELLED_BY_DRIVER_UNCOOPERATIVE_PASSENGER',
	CANCELLED_BY_DRIVER_OTHER_REASON = 'CANCELLED_BY_DRIVER_OTHER_REASON',
}
